import { render, staticRenderFns } from "./RejectedApplication.vue?vue&type=template&id=76a35804&scoped=true"
import script from "./RejectedApplication.vue?vue&type=script&lang=js"
export * from "./RejectedApplication.vue?vue&type=script&lang=js"
import style0 from "./RejectedApplication.vue?vue&type=style&index=0&id=76a35804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a35804",
  null
  
)

export default component.exports